import { Heading, Para } from "@/components/ui/typography";
import { listDocs } from "@webapp/utils/content.server";
import { DOC_ICONS } from "@webapp/utils/doc-icons";
import { buildPageMeta } from "@webapp/utils/page-meta";
import { Link } from "react-router";
import type { Route } from "./+types/docs._index";

const TITLE = "Docs · HypeStream";
const DESCRIPTION =
  "How to use every part of the HypeStream app: the inbox, reviews, customer breakdown, recordings and more.";

export const meta: Route.MetaFunction = () =>
  buildPageMeta({ path: "/docs", title: TITLE, description: DESCRIPTION });

export function loader() {
  return { docs: listDocs() };
}

export default function DocsIndex({ loaderData }: Route.ComponentProps) {
  return (
    <div>
      <Heading size="h1">Docs</Heading>
      <Para muted className="mt-3 max-w-2xl">
        The app&apos;s left-hand bar is icons only. Find the icon below to learn what that tab does.
        Stuck? Email{" "}
        <a href="mailto:hypestream.io@gmail.com" className="underline">
          hypestream.io@gmail.com
        </a>{" "}
        or call{" "}
        <a href="tel:+15034043514" className="underline">
          +1 (503) 404-3514
        </a>
        .
      </Para>
      <div className="mt-8 grid gap-4 sm:grid-cols-2" data-testid="docs-overview">
        {loaderData.docs.map((doc) => {
          const Icon = DOC_ICONS[doc.frontmatter.icon];
          return (
            <Link
              key={doc.slug}
              to={`/docs/${doc.slug}`}
              className="group flex gap-4 rounded-xl border bg-card p-4 transition-colors hover:border-primary/50"
            >
              <span className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-muted">
                <Icon className="size-5" />
              </span>
              <span>
                <span className="block font-semibold group-hover:text-primary">
                  {doc.frontmatter.tab}
                </span>
                <span className="mt-1 block text-sm text-muted-foreground">
                  {doc.frontmatter.description}
                </span>
              </span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
